angular.module('routes.cases.CasesController', [
  'stack',
  'angularMoment'
])

/**
 * The CasesController manages view logic rendered to the
 * case.html template for the /case view.
 *
 * @class CasesController
 * @constructor
 * @module routes.cases.CasesController
 */
.controller('CasesController', [
  '$scope',
  '$state',
  '$rootScope',
  '$location',
  '$sce',
  '$window',
  'constants',
  'ModelsService',
  'CasesService',
  'DuplicateService',
  'LTIService',
  'LocalStorageService',
  'PaginationService',
  'GLOBAL',
  function (
    $scope,
    $state,
    $rootScope,
    $location,
    $sce,
    $window,
    constants,
    ModelsService,
    CasesService,
    DuplicateService,
    LTIService,
    LocalStorageService,
    PaginationService,
    GLOBAL
  ) {
    'use strict';

    $scope.constants = null;

    $scope.state = $state;

    $scope.caselist = [];

    $scope.cases = {
      list: [],
      current: null
    };

    $scope.states = {
      list: [],
      current: null
    };

    $scope.widgets = {
      list: [],
      all: [],
      active: [],
      current: null
    };

    $scope.create = {
      title: null,
      group: null
    };

    $scope.launchData = {
      role: 'student',
      mode: 'practice',
      environment: 'current'
    };

    $scope.isEdit = null;

    $scope.caseEdit = null;

    // what value to sort on
    $scope.sortType = '';
    // default sort order ascending
    $scope.sortReverse = false;
    // start with no search
    $scope.searchLabel = '';

    $scope.processing = false;

    $scope.currentContent = null;

    $scope.isLiveAuthoring = $location.host() === 'dev-dcs.pearsoncmg.com';

    $scope.$on('setCurrentContentScope', function (event, contentScope) {
      $scope.currentContent = contentScope;
    });


    /**
     * Launches cases remote bypassing LTI to test
     * various user roles and environments
     *
     * @param {Object} caseObj - Case object
     * @param {string} env - environment string
     * @param {string} role - user role
     */
    $scope.launchCaseRemote = function launchCaseRemote(caseObj, env, role) {
      var form;
      var params = {
        caseId: caseObj.id,
        role: role,
        env: env,
        mode: 'practice'
      };

      LTIService
        .getSignedPayload(params)
        .then(function (response) {
          form = angular.element('#magic-hidden-form');
          form.empty();
          form.attr('action', response.data.launchTargetUrl);
          _.forEach(response.data.launchData, function (value, key) {
            form.append('<input type="hidden" name="' + key + '" value="' + value + '">');
          });
          form.submit();
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };


    /**
     * Launches cases locally bypassing LTI to test
     * various user roles and environments
     *
     * @param {Object} caseObj - Case object
     */
    $scope.launchCaseLocal = function launchCaseLocal(caseObj) {
      var location = $scope.deliveryPath + caseObj.id + '/states/' + caseObj.content.start + '#access_token=' + LocalStorageService.get('newman').token;
      $window.open(location);
    };

    /**
     * Updates the lists within a case
     */
    $scope.updateList = function updateList() {
      defineStateList();
    };

    /**
     * Duplicates an entire case
     *
     * @param {string} id - Case identifier
     */
    $scope.duplicateCase = function duplicateCase(id) {
      $scope.duplicating = id;

      DuplicateService
        .duplicateCase(id)
        .then(function () {
          reloadView();
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * Moves view into editing state
     *
     * @param {string} id - Case identifier
     */
    $scope.editCase = function editCase(id) {
      var c = CasesService.get(id);
      $scope.editConfirm = id;
      $scope.caseEdit = {
        label: c.label,
        group: c.content.group,
        theme: c.content.theme,
        start: c.content.start
      };
    };

    /**
     * Stores the entered information
     * and moves view back into read state
     *
     * @param {Object} id - ID of case to save
     */
    $scope.saveEditCase = function saveEditCase(id) {
      var data = {
        content: {
          group: $scope.caseEdit.group,
          theme: $scope.caseEdit.theme,
          start: $scope.caseEdit.start
        },
        label: $scope.caseEdit.label,
        schema: 'cases'
      };

      CasesService
        .update(id, data)
        .then(function () {
          reloadView();
          return;
        })
        .catch(function () {
          console.error('Error editing case');
        });
    };

    /**
     * Moves view into read state
     */
    $scope.cancelEditCase = function cancelEditCase() {
      $scope.editConfirm = null;
    };

    /**
     * Creates a new case based on form data
     *
     * @param {Object} form - Form object
     */
    $scope.saveCreateCase = function saveCreateCase(form) {
      var data = {
        content: {
          group: $scope.create.group,
          theme: $scope.create.theme
        },
        label: $scope.create.title,
        schema: 'cases'
      };

      if (form.$valid) {
        CasesService
          .create(data)
          .then(function () {
            reloadView();
            return;
          })
          .catch(function () {
            console.error('Error creating case');
          });
      }
    };

    /**
     * Initiates the deletion process for a case
     *
     * @param {string} caseId - Case identifier
     */
    $scope.deleteCase = function deleteCase(caseId) {
      $scope.deleteConfirm = caseId;
    };

    /**
     * Confirms the deletion of a case
     *
     * @param {string} caseId - Case identifier
     */
    $scope.confirmDeleteCase = function confirmDeleteCase(caseId) {
      var deletecase = _.findIndex($scope.caselist.records, { id: caseId });
      CasesService
        .remove(caseId)
        .then(function () {
          $scope.caselist.records.splice(deletecase, 1);
          return;
        })
        .catch(function () {
          console.error('Error deleting case');
        });
    };

    /**
     * Cancels the delete operation
     */
    $scope.cancelDelete = function cancelDelete() {
      $scope.deleteConfirm = null;
    };

    /**
     * UI trigger for toggling the active status of a widget
     * inside of a state
     *
     * @param {string} widgetId - Widget identifier
     * @param {boolean} status - Whether the widget is active in the current state
     */
    $scope.setWidgetActive = function setWidgetActive(widgetId, status) {
      var data = {
        relatives: []
      };
      var endpoint;

      $scope.widgets.active[widgetId] = status;

      // remove all widget references from state relatives
      $scope.states.current.relatives = _
        .reject(
          $scope.states.current.relatives,
          { model: 'widgets' }
        );

      // add selected widgets
      _.forEach($scope.widgets.all, function (widget) {
        if ($scope.widgets.active[widget.id]) {
          $scope.states.current.relatives = CasesService
            .createRelative($scope.states.current.relatives, widget);
        } else {
          $scope.states.current.relatives = CasesService
            .rejectRelative($scope.states.current.relatives, widget.id);
        }
      });

      data.relatives = $scope.states.current.relatives;

      endpoint = ModelsService.find('states', 'id', $scope.states.current.id);

      ModelsService
        .update(endpoint, data)
        .then(function () {
          $state.go('routes.cases.states.widgets', { widgetMode: null }, { reload: true });
          return;
        })
        .catch(function (err) {
          console.log(err);
        });
    };

    /**
     * Method copies resolved constants into the controller
     * namespace during the initalization process.
     *
     * @private
     */
    function defineConstants() {
      $scope.constants = constants;

      $scope.duplicating = null;
    }

    /**
     * Reloads the current view and picks up
     * data changes from payload resolvers
     */
    function reloadView() {
      $scope.caselist.needsReload = true;
      $scope.caselist.fullset = false;

      $state.transitionTo($state.current, $state.params, {
        reload: true,
        inherit: false,
        notify: true
      });
    }

    /**
     * Method initializes case list
     *
     * @private
     */
    function initCases() {
      ModelsService.initialize('cases', GLOBAL.apiPath + '/cases')
      .then(function () {
        $scope.cases.list = CasesService.get();
        PaginationService.updateFullSet('cases', ['content.group']);
        return true;
      }).catch(function () {
        return false;
      });
    }

    /**
     * Method sets case data from Model
     *
     * @private
     */
    function defineCaseList() {
      $scope.caselist = PaginationService.get('cases');
      if ($scope.caselist === undefined) {
        $scope.caselist = PaginationService.paginate('cases', GLOBAL.apiPath + '/cases', { limit: 10 })
        .then(function () {
          initCases();
          return PaginationService.get('cases');
        });
      } else if (!_.isUndefined(CasesService.get()) && !$scope.caselist.needsReload) {
        $scope.caselist.needsReload = false;
        $scope.cases.list = CasesService.get();
      } else {
        initCases();
      }
    }

    /**
     * Defines the current case
     */
    function defineCurrentCase() {
      if ($state.params.caseId) {
        $scope.cases.current = CasesService.get($state.params.caseId);
        console.log('Current Case: ', $scope.cases.current.id, $scope.cases.current.label);
      } else {
        $scope.cases.current = null;
        $scope.caseEdit = null;
      }
    }

    /**
     * Method sets state data from Model
     *
     * @private
     */
    function defineStateList() {
      var stateList = [];

      if ($scope.cases.current) {
        stateList = _.filter($scope.cases.current.relatives, function (obj) {
          return _.includes(obj.classes, 'states');
        });
      }

      $scope.states.list = stateList;

      if ($state.params.stateId) {
        /* $scope.states.current = _.find($scope.states.list, function (obj) {
          return obj.id === $state.params.stateId;
        });*/
        $scope.states.current = ModelsService.find('states', 'id', $state.params.stateId);
      }
    }

    /**
     * Defines the path and framesrc for delivery
     */
    function defineDelivery() {
      var authoring = _.find($rootScope.config.APPS, { port: $location.port() });
      var delivery = _.find($rootScope.config.APPS, { id: authoring.match });

      $scope.deliveryPath = $location
        .absUrl()
        .replace(authoring.port, delivery.port).replace('cases', 'simulation');
      $scope.deliveryPath = $scope.deliveryPath.split('?')[0];
      $scope.framesrc = $sce
        .trustAsResourceUrl($scope.deliveryPath + '?newman#access_token=' + LocalStorageService.get('newman').token);
    }

    /**
     * Updates the state of the authoring application to coincide with a change in state
     * in the nested delivery application
     *
     * @param {Object} event - event object
     */
    $scope.deliveryStateChange = function (event) {
      if ($state.params.stateId !== event.data.stateId
        || (event.data.widgetId === undefined && $state.params.stateId === event.data.stateId)) {
        $state.go(
          'routes.cases.states',
          { stateId: event.data.stateId, stateMode: null },
          { reload: true }
        );
      }

      if ($state.params.widgetId !== event.data.widgetId && event.data.widgetId !== undefined) {
        $state.go(
          'routes.cases.states.widgets',
          { widgetId: event.data.widgetId, widgetMode: null },
          { reload: true }
        );
      }
    };

    /**
     * Method executes the initialization process.
     *
     * @private
     */
    function initialize() {
      defineConstants();
      defineCaseList();
      defineCurrentCase();
      defineStateList();
      defineDelivery();

      if (!$rootScope.listener) {
        $window.addEventListener('message', $scope.deliveryStateChange, false);
        $rootScope.listener = true;
      }
    }
    initialize();
  }
]);
